export let CurrierStatus = /*#__PURE__*/function (CurrierStatus) {
  CurrierStatus["UNINITIALIZED"] = "UNINITIALIZED";
  CurrierStatus["CREATED"] = "CREATED";
  CurrierStatus["REJECTED"] = "REJECTED";
  return CurrierStatus;
}({});
//# sourceMappingURL=index.js.map